module.exports = __webpack_public_path__ + "img/pizza.8429d184.svg";